import { toValue } from 'vue'
import { defineStore } from 'pinia'
import { set as _set } from 'lodash'
import axios from '@/vendors/axios/axios'
import OpenStreetMapAddresses from '@/classes/addresses/OpenStreetMapAddresses'
import Query from '@/classes/queries/Query'

export const useOpenStreetMapStore = defineStore('OpenStreetMapStore', {
  state: () => ({
    suggestions: {},
    loader: false,
    error: {}
  }),
  getters: {
    getSuggestions: state => ({ query, dependencies = [] } = {}) => {
      return state.$getItems({
        resource: 'suggestions',
        query,
        dependencies,
        fetch: () => state.fetchSuggestions({ query })
      })
    }
  },
  actions: {
    async fetchSuggestions ({ query }) {
      if (query.value.q?.length <= 3) return

      const q = new Query({ query: toValue(query) }).to_string

      _set(this.suggestions, `['${q}'].error`, null)
      _set(this.suggestions, `['${q}'].status`, 'processing')

      try {
        const { data } = await axios.get(`https://nominatim.openstreetmap.org/search${q}`)

        _set(this.suggestions, `['${q}'].items`, new OpenStreetMapAddresses(data))
        _set(this.suggestions, `['${q}'].status`, 'success')
      } catch {
        _set(this.suggestions, `['${q}'].error`, 'errors.an_error_occurred_please_try_again_in_a_few_moments')
        _set(this.suggestions, `['${q}'].status`, 'failure')
      }
    }
  }
})